export default "__VITE_ASSET__BEXT3okV__"